const generalCss = {
    primaryFadedBgColor: "#EFF4F9",
    appMaxWidth: "1400px",
    sectionBlueBg:"rgba(239, 244, 249, 0.5)"
}

export default generalCss